import { render, staticRenderFns } from "./NewsTabBar.vue?vue&type=template&id=2e441c9a"
import script from "./NewsTabBar.vue?vue&type=script&lang=js"
export * from "./NewsTabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports